import {
  archivoUrl as urlWhatsapp,
  VIGENCIA as VIGENCIA_WHATSAPP,
} from "./comprobantes";
import { archivoUrl as urlMail, VIGENCIA as VIGENCIA_MAIL } from "./facturasMail";

/* El papel de un comprobante: si se dibuja como imagen y el link firmado.
 *
 * Vivía adentro de «Facturas y remitos». Pasó acá porque ahora lo usan dos
 * pantallas —esa y Proveedores › Facturas a pagar— y el papel es el mismo:
 * dos copias de la misma regla son dos reglas el día que una cambia. */

/* ¿El papel se puede dibujar como imagen? Lo dice el `mime`, no por dónde vino:
   por WhatsApp también se mandan PDF, y un PDF adentro de un `<img>` es una
   imagen rota. Las filas viejas de WhatsApp no traen `mime` (eran todas fotos):
   ésas siguen siendo imagen, salvo que el archivo se llame `.pdf`. */
export const esImagen = (origen, f) => {
  const mime = String(f.mime || "").toLowerCase();
  if (mime) return mime.startsWith("image/");
  const ruta = String((origen === "whatsapp" ? f.archivo : f.ruta) || "");
  return origen === "whatsapp" && !/\.pdf$/i.test(ruta);
};

/* Firma el papel y devuelve `{ url, vence }`, o null si no se pudo. `vence` se
   cuenta desde ANTES de pedir la firma: Storage fija el vencimiento cuando
   firma, y contarlo desde la respuesta lo correría lo que tardó la red. */
export async function firmarPapel(origen, ruta) {
  if (!ruta) return null;
  const esWA = origen === "whatsapp";
  const desde = Date.now();
  try {
    const url = await (esWA ? urlWhatsapp : urlMail)(ruta);
    const vigencia = esWA ? VIGENCIA_WHATSAPP : VIGENCIA_MAIL;
    return url ? { url, vence: desde + vigencia * 1000 } : null;
  } catch {
    return null;
  }
}
